import { EUDealer } from '@models/preferred-dealer';
import { VehicleOptions } from '@smart-tiles/smart-tile-preferred-dealer/preferred-dealer-modal';

export function updateDealerInfo(
    dealerInfo: EUDealer | undefined,
    listItem: VehicleOptions,
    errorText: string
): VehicleOptions {
    if (
        dealerInfo?.DealerName &&
        dealerInfo?.AddressLine1 &&
        dealerInfo?.Locality &&
        dealerInfo?.PostCode
    ) {
        listItem.preferredDealerName = dealerInfo.DealerName;
        listItem.preferredDealerAddress = dealerInfo.AddressLine1;
        listItem.preferredDealerCityStateZip = `${dealerInfo.Locality}, ${dealerInfo.PostCode}`;
        listItem.preferredDealerPhoneNumber = dealerInfo.PrimaryPhone;
    } else {
        listItem.dealerInfoError = errorText;
    }
    return listItem;
}
